import { render } from "./Searches.vue?vue&type=template&id=cad5d32a&ts=true"
import script from "./Searches.vue?vue&type=script&lang=ts"
export * from "./Searches.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__